<template>
  <div>
    <!-- 頭 -->
    <nav class="navbar" v-if="ApplyData">
      <div class="container">
        <div class="menu_box">
          <div class="logo_box">
            <img :src="ApplyData.SiteLogo" alt="">
            <h1>
              外交部「國際青年大使交流計畫」
              <br>
              線上報名系統
            </h1>
          </div>
          <ul class="menu">
            <li class="" v-if="!ApplyData.LoginToken">
              <router-link to="/">
                <p>回首頁</p>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="top_btn">
      <a href="javascript:void(0)" @click="toTop()">
        <p>TOP</p>
      </a>
    </div>
    <div class="wrapper youth_ambassadors" v-if="ApplyData && ApplyData.Apply">
      <!-- <img class="img_bg img_6" src="img/img_6.svg" alt=""> -->
      <img class="img_bg img_5" src="img/img_5.svg" alt="">
      <div class="container">
        <div class="form_box">
          <div class="title">
            <h2 v-if="!ApplyData.LoginToken"><img src="img/icon_5.svg" alt="">線上報名</h2>
            <h2 v-if="ApplyData.LoginToken"><img src="img/icon_5.svg" alt="">編輯 - {{ ApplyData.Apply.ApplyId }}</h2>
            <button class="print_btn" @click="print()">
              <svg id="" data-name="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103.98 103.98">
                <path class="cls-1"
                  d="M88.75,26.2h-2.84v-10.97c0-8.4-6.83-15.23-15.23-15.23h-37.37c-8.4,0-15.23,6.83-15.23,15.23v10.97h-2.84c-8.4,0-15.23,6.83-15.23,15.23v24.37c0,8.4,6.83,15.23,15.23,15.23h2.84v13.81c0,5.04,4.1,9.14,9.14,9.14h49.55c5.04,0,9.14-4.1,9.14-9.14v-13.81h2.84c8.4,0,15.23-6.83,15.23-15.23v-24.37c0-8.4-6.83-15.23-15.23-15.23ZM24.17,15.23c0-5.04,4.1-9.14,9.14-9.14h37.37c5.04,0,9.14,4.1,9.14,9.14v10.97H24.17v-10.97ZM79.81,94.84c0,1.68-1.37,3.05-3.05,3.05H27.21c-1.68,0-3.05-1.37-3.05-3.05v-30.06h55.64v30.06ZM97.89,65.8c0,5.04-4.1,9.14-9.14,9.14h-2.84v-10.15h1.83c1.68,0,3.05-1.36,3.05-3.05s-1.36-3.05-3.05-3.05H16.25c-1.68,0-3.05,1.36-3.05,3.05s1.36,3.05,3.05,3.05h1.83v10.15h-2.84c-5.04,0-9.14-4.1-9.14-9.14v-24.37c0-5.04,4.1-9.14,9.14-9.14h73.52c5.04,0,9.14,4.1,9.14,9.14v24.37Z" />
                <path class="cls-1"
                  d="M60.11,71.69h-16.25c-1.68,0-3.05,1.36-3.05,3.05s1.36,3.05,3.05,3.05h16.25c1.68,0,3.05-1.36,3.05-3.05s-1.36-3.05-3.05-3.05Z" />
                <path class="cls-1"
                  d="M60.11,84.69h-16.25c-1.68,0-3.05,1.36-3.05,3.05s1.36,3.05,3.05,3.05h16.25c1.68,0,3.05-1.36,3.05-3.05s-1.36-3.05-3.05-3.05Z" />
                <path class="cls-1"
                  d="M25.99,39.2h-9.75c-1.68,0-3.05,1.36-3.05,3.05s1.36,3.05,3.05,3.05h9.75c1.68,0,3.05-1.36,3.05-3.05s-1.36-3.05-3.05-3.05Z" />
              </svg>
              列印
            </button>
          </div>
          <div class="box">
            <template v-if="!ApplyData.LoginToken && ApplyData.Apply.Status != 0">
              <div class="group full">
                <label class="form-label">審核結果</label>
                <br />
                <span style="font-size: 1.5rem;" v-if="ApplyData.Apply.Status == 1">
                  感謝您報名「{{ApplyData.SeasonName}}」，我們已收到您的報名資料，您的線上報名序號為 {{ApplyData.Apply.ApplyId}}。我們將依相關規定進行審核，敬請稍候審核結果。
                </span>
                <span style="font-size: 1.5rem; color: blue;" v-if="ApplyData.Apply.Status == 2">通過</span>
                <span style="font-size: 1.5rem; color: red;" v-if="ApplyData.Apply.Status == 3">未通過</span>
              </div>
              <div class="group full autobiography_box"
                v-if="ApplyData.Apply.Status == 3 && ApplyData.Apply.ReviewContent">
                <label class="form-label">審核說明</label>
                <br />
                <span style="font-size: 1.5rem; color: red; white-space: pre-line;">{{ ApplyData.Apply.ReviewContent
                }}</span>
              </div>
              <hr class="divider">
            </template>
            <div class="group">
              <label for="Name" class="form-label"><span>*</span>姓名</label>
              <input type="text" class="form-control" id="Name" placeholder="請輸入姓名" v-model="ApplyData.Apply.Name"
                data-required="1" data-required-msg="請輸入姓名" v-if="ApplyData.Apply.AId == -1">
              <input type="text" class="form-control" id="Name" placeholder="請輸入姓名" v-model="ApplyData.Apply.Name"
                data-required="1" data-required-msg="請輸入姓名" disabled v-else>
            </div>
            <div class="group">
              <label class="form-label"><span>*</span>性別</label>
              <div class="gender_box">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="Gender" id="Gender_F"
                    v-model="ApplyData.Apply.Gender" data-required="1" data-required-msg="請選擇性別" v-bind:value="'女'">
                  <label class="form-check-label" for="Gender_F">
                    女
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="Gender" id="Gender_M"
                    v-model="ApplyData.Apply.Gender" data-required="1" data-required-msg="請選擇性別" v-bind:value="'男'">
                  <label class="form-check-label" for="Gender_M">
                    男
                  </label>
                </div>
                <div class="form-check" v-if="false">
                  <input class="form-check-input" type="radio" name="Gender" id="Gender_O"
                    v-model="ApplyData.Apply.Gender" data-required="1" data-required-msg="請選擇性別" v-bind:value="'其他'">
                  <label class="form-check-label" for="Gender_O">
                    其他
                  </label>
                </div>
              </div>
            </div>
            <div class="group date_box">
              <label for="datepicker" class="form-label"><span>*</span>出生日期</label>
              <div class="div">
                <input type="date" class="form-control" id="datepicker" placeholder="請輸入出生日期" data-required="1"
                  data-required-msg="請輸入出生日期" v-model="ApplyData.Apply.BirthDate">
                <div id="result" class="date_p"></div>
              </div>
            </div>
            <div class="group">
              <label class="form-label"><span>*</span>身分證字號</label>
              <input type="text" class="form-control" placeholder="請輸入身分證字號" data-required="1"
                data-required-msg="請輸入身分證字號" v-model="ApplyData.Apply.IDNumber" v-if="ApplyData.Apply.AId == -1"
                maxlength="10">
              <input type="text" class="form-control" placeholder="請輸入身分證字號" data-required="1"
                data-required-msg="請輸入身分證字號" v-model="ApplyData.Apply.IDNumber" disabled v-else maxlength="10">
            </div>
            <div class="group full">
              <label class="form-label"><span>*</span>通訊地址</label>
              <input type="text" class="form-control" placeholder="請輸入通訊地址" data-required="1"
                data-required-msg="請輸入通訊地址" v-model="ApplyData.Apply.Address">
            </div>
            <div class="group">
              <label class="form-label"><span>*</span>聯絡電話（手機）</label>
              <input type="text" class="form-control" placeholder="請輸入聯絡電話" data-required="1"
                data-required-msg="請輸入聯絡電話" v-model="ApplyData.Apply.PhoneNumber">
            </div>
            <div class="group">
              <label class="form-label"><span>*</span>電子郵件</label>
              <input type="email" class="form-control" placeholder="請輸入電子郵件" data-required="1"
                data-required-msg="請輸入電子郵件" v-model="ApplyData.Apply.Email">
            </div>
            <div class="group">
              <label class="form-label"><span>*</span>Line帳號（無則填寫”無”）</label>
              <input type="text" class="form-control" placeholder="請輸入Line帳號" data-required="1"
                data-required-msg="請輸入Line帳號" v-model="ApplyData.Apply.LineAccount">
            </div>
            <div class="group space_box"></div>
            <div class="group">
              <label class="form-label"><span>*</span>護照姓名 Surname+Given Name <br>（倘無護照，請寫"申辦中"）</label>
              <input type="text" class="form-control" placeholder="請輸入護照姓名" data-required="1"
                data-required-msg="請輸入護照姓名" v-model="ApplyData.Apply.PassportName">
            </div>
            <div class="group">
              <label class="form-label"><span>*</span>護照號碼 <br>（倘無護照，請寫"申辦中"）</label>
              <input type="text" class="form-control" placeholder="請輸入護照號碼" data-required="1"
                data-required-msg="請輸入護照號碼" v-model="ApplyData.Apply.PassportNumber">
            </div>
            <hr class="divider">
            <div class="group">
              <label class="form-label"><span>*</span>就讀學校（完整名稱）</label>
              <select id="schoolSelect" style="width:100%" data-required="1"
                data-required-msg="請選擇就讀學校">
                <option value=""></option>
              </select>
            </div>
            <div class="group">
              <label class="form-label"><span>*</span>就讀系所</label>
              <input type="text" class="form-control" placeholder="請輸入就讀系所" data-required="1"
                data-required-msg="請輸入就讀系所" v-model="ApplyData.Apply.Department">
            </div>
            <div class="group">
              <label class="form-label"><span>*</span>就讀年級</label>
              <input type="text" class="form-control" placeholder="請輸入就讀年級" data-required="1"
                data-required-msg="請輸入就讀年級" v-model="ApplyData.Apply.Grade">
            </div>
            <hr class="divider">
            <div class="group">
              <label class="form-label"><span>*</span>緊急聯絡人姓名</label>
              <input type="text" class="form-control" placeholder="請輸入緊急聯絡人姓名" data-required="1"
                data-required-msg="請輸入緊急聯絡人姓名" v-model="ApplyData.Apply.EmergencyContactName">
            </div>
            <div class="group">
              <label class="form-label"><span>*</span>緊急聯絡人手機號碼</label>
              <input type="text" class="form-control" placeholder="請輸入緊急聯絡人手機號碼" data-required="1"
                data-required-msg="請輸入緊急聯絡人手機號碼" v-model="ApplyData.Apply.EmergencyContactPhone">
            </div>
            <div class="group">
              <label class="form-label"><span>*</span>與緊急聯絡人的關係</label>
              <input type="text" class="form-control" placeholder="請輸入與緊急聯絡人的關係" data-required="1"
                data-required-msg="請輸入與緊急聯絡人的關係" v-model="ApplyData.Apply.EmergencyContactRelation">
            </div>
            <hr class="divider">
            <div class="group full">
              <label class="form-label"><span>*</span>應試專長 <span class="red_color">（擇一應試，選定後不得更改）</span></label>
              <div class="expertise_box">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="Specialty" id="Specialty_1"
                    v-model="ApplyData.Apply.Specialty" data-required="1" data-required-msg="請選擇應試專長"
                    v-bind:value="'外語宣介－英文'">
                  <label class="form-check-label" for="Specialty_1">
                    外語宣介－英文
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="Specialty" id="Specialty_2"
                    v-model="ApplyData.Apply.Specialty" data-required="1" data-required-msg="請選擇應試專長"
                    v-bind:value="'文化才藝－音樂'">
                  <label class="form-check-label" for="Specialty_2">
                    文化才藝－音樂
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="Specialty" id="Specialty_3"
                    v-model="ApplyData.Apply.Specialty" data-required="1" data-required-msg="請選擇應試專長"
                    v-bind:value="'文化才藝－舞蹈'">
                  <label class="form-check-label" for="Specialty_3">
                    文化才藝－舞蹈
                  </label>
                </div>
                <div class="form-check" v-if="false">
                  <input class="form-check-input" type="radio" name="Specialty" id="Specialty_4"
                    v-model="ApplyData.Apply.Specialty" data-required="1" data-required-msg="請選擇應試專長"
                    v-bind:value="'技藝專長'">
                  <label class="form-check-label" for="Specialty_4">
                    技藝專長
                  </label>
                </div>
              </div>
            </div>
            <div class="group full">
              <label class="form-label"><span>*</span>應試專長具體項目 （請分點條列說明，以下為舉例：英語、二胡、扯鈴、芭蕾舞、傳統戲曲、原住民音樂舞蹈等）</label>
              <textarea class="no-print" placeholder="請輸入應試專長具體項目" data-required="1" data-required-msg="請輸入應試專長具體項目"
                v-model="ApplyData.Apply.SpecificSpecialty"></textarea>
              <div class="print-only">{{ ApplyData.Apply.SpecificSpecialty }}</div>
            </div>
            <div class="group full">
              <label class="form-label"><span>*</span>複選地點<span class="red_color">（選定後不得更改；地點由主辦單位排定後通知）</span></label>
              <div class="place_box">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="PreferredLocation" id="PreferredLocation_1"
                    v-model="ApplyData.Apply.PreferredLocation" data-required="1" data-required-msg="請選擇複選地點"
                    v-bind:value="'北區'">
                  <label class="form-check-label" for="PreferredLocation_1">
                    北區（6月14日）
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="PreferredLocation" id="PreferredLocation_2"
                    v-model="ApplyData.Apply.PreferredLocation" data-required="1" data-required-msg="請選擇複選地點"
                    v-bind:value="'中南區'">
                  <label class="form-check-label" for="PreferredLocation_2">
                    中南區（6月15日）
                  </label>
                </div>
              </div>
            </div>
            <div class="group full">
              <label class="form-label">第二外語或才藝專長（如德語、日語、法語，歌唱、街舞、攝影等）</label>
              <textarea class="no-print" placeholder="請輸入第二外語或才藝專長"
                v-model="ApplyData.Apply.SecondLanguageOrSkill"></textarea>
              <div class="print-only">{{ ApplyData.Apply.SecondLanguageOrSkill }}</div>
            </div>
            <div class="group full">
              <label class="form-label">個人重要經歷（曾任學校社團領導幹部或志工、赴海外交換學生及攻讀學會等，倘有原住民身分請註明，字數100字內）</label>
              <textarea class="no-print" placeholder="請輸入個人重要經歷" v-model="ApplyData.Apply.KeyExperience"></textarea>
              <div class="print-only">{{ ApplyData.Apply.KeyExperience }}</div>
            </div>
            <div class="group full">
              <label class="form-label"><span>*</span>曾在美國逾期居留或遭美國政府拒發旅行文件</label>
              <div class="overdue_box">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="OverstayInUSA" id="OverstayInUSA_N"
                    v-model="ApplyData.Apply.OverstayInUSA" v-bind:value="false">
                  <label class="form-check-label" for="OverstayInUSA_N">
                    無
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="OverstayInUSA" id="OverstayInUSA_Y"
                    v-model="ApplyData.Apply.OverstayInUSA" v-bind:value="true">
                  <label class="form-check-label" for="OverstayInUSA_Y">
                    有，請敘明原因：
                  </label>
                  <input type="text" class="form-control" :data-required="ApplyData.Apply.OverstayInUSA ? '1' : '0'"
                    data-required-msg="請敘明曾在美國逾期居留或遭美國政府拒發旅行文件原因" v-model="ApplyData.Apply.OverstayReason">
                </div>
              </div>
            </div>
            <div class="group full autobiography_box">
              <label class="form-label"><span>*</span>自傳（內容包含成長經歷、興趣專長、對擔任「國際青年大使」之自我期許，字數400字內）</label>
              <textarea class="no-print" maxlength="400" placeholder="請輸入自傳" data-required="1" data-required-msg="請輸入自傳"
                v-model="ApplyData.Apply.Autobiography"></textarea>
              <div class="print-only">{{ ApplyData.Apply.Autobiography }}</div>
            </div>
            <hr class="divider no-print">
            <div class="group input-group full no-print">
              <label class="form-label"><span>*</span>學生證正反面或在學證明</label>
              <p class="red_color">*學生證請確認已蓋有最新學期註冊章，若為悠遊卡形式，無法證明學生仍在校者，請檢附在學證明文件。&nbsp;</p>
              <span style="color: red;"
                v-if="ApplyData.Apply.AId != -1 && ApplyData.Apply.StudentIDOrProof && !ApplyData.LoginToken">(已上傳,
                可更新)</span>
              <a :href="StudentIDOrProof_Url" target="_blank"
                v-if="StudentIDOrProof_Url && ApplyData.LoginToken">另開新視窗檢視</a>
              <div class="file_preview" v-if="getPreviewUrl(ApplyData.Apply.StudentIDOrProof)">
                <img :src="getPreviewUrl(ApplyData.Apply.StudentIDOrProof)" alt="預覽圖">
              </div>
              <div class="file_box">
                <input type="file" class="form-control" id="StudentIDOrProof"
                  accept=".pdf,.bmp,.jpg,.gif,.tif,.png,.jpeg" @change="checkFiles">
                <input type="hidden" id="StudentIDOrProof_name" data-namgtag="1" />
                <input type="hidden" v-model="ApplyData.Apply.StudentIDOrProof" id="StudentIDOrProof_data"
                  data-required="1" data-required-msg="請上傳學生證正反面或在學證明" />
                <label class="input-group-text" for="StudentIDOrProof">上傳檔案</label>
              </div>
              <p class="upload_p">可上傳的檔案格式為 .pdf .bmp .jpg .gif .tif .png .jpeg </p>
            </div>
            <div class="group input-group full no-print">
              <label class="form-label"><span>*</span>個人脫帽半身照片 </label><span style="color: red;"
                v-if="ApplyData.Apply.AId != -1 && ApplyData.Apply.PersonalPhoto && !ApplyData.LoginToken">(已上傳,
                可更新)</span>
              <a :href="PersonalPhoto_Url" target="_blank" v-if="PersonalPhoto_Url && ApplyData.LoginToken">另開新視窗檢視</a>
              <div class="file_preview" v-if="getPreviewUrl(ApplyData.Apply.PersonalPhoto)">
                <img :src="getPreviewUrl(ApplyData.Apply.PersonalPhoto)" alt="預覽圖">
              </div>
              <div class="file_box">
                <input type="file" class="form-control" id="PersonalPhoto" accept=".pdf,.bmp,.jpg,.gif,.tif,.png,.jpeg"
                  @change="checkFiles">
                <input type="hidden" id="PersonalPhoto_name" data-namgtag="1" />
                <input type="hidden" v-model="ApplyData.Apply.PersonalPhoto" id="PersonalPhoto_data" data-required="1"
                  data-required-msg="請上傳個人脫帽半身照片" />
                <label class="input-group-text" for="PersonalPhoto">上傳檔案</label>
              </div>
              <p class="upload_p">可上傳的檔案格式為 .pdf .bmp .jpg .gif .tif .png .jpeg </p>
            </div>
            <div class="group input-group full no-print">
              <label class="form-label"><span>*</span>個人影音資料使用同意書 <a class="consent_form"
                  href="https://youthambassador.tw/Upload/FileManager/5602dfbb-cd1d-47aa-93c0-e54b42d01b77.pdf">下載同意書</a>
              </label><span style="color: red;"
                v-if="ApplyData.Apply.AId != -1 && ApplyData.Apply.MediaConsentForm && !ApplyData.LoginToken">(已上傳,
                可更新)</span>
              <a :href="MediaConsentForm_Url" target="_blank"
                v-if="MediaConsentForm_Url && ApplyData.LoginToken">另開新視窗檢視</a>
              <div class="file_preview" v-if="getPreviewUrl(ApplyData.Apply.MediaConsentForm)">
                <img :src="getPreviewUrl(ApplyData.Apply.MediaConsentForm)" alt="預覽圖">
              </div>
              <div class="file_box">
                <input type="file" class="form-control" id="MediaConsentForm"
                  accept=".pdf,.bmp,.jpg,.gif,.tif,.png,.jpeg" @change="checkFiles">
                <input type="hidden" id="MediaConsentForm_name" data-namgtag="1" />
                <input type="hidden" v-model="ApplyData.Apply.MediaConsentForm" id="MediaConsentForm_data"
                  data-required="1" data-required-msg="請上傳個人影音資料使用同意書" />
                <label class="input-group-text" for="MediaConsentForm">上傳檔案</label>
              </div>
              <p class="upload_p">可上傳的檔案格式為 .pdf .bmp .jpg .gif .tif .png .jpeg </p>
            </div>
            <hr class="divider">
            <div class="group full">
              <label class="form-label"><span>*</span>推薦信（目前所屬學校或系所或修課教授(或教師)用印或簽名之推薦函至少一封，格式請自訂）</label>
              <div class="place_box">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="RecommendationLetter" id="RecommendationLetter_1"
                    v-model="ApplyData.Apply.RecommendationLetter" data-required="1" data-required-msg="請選擇推薦信提供方式"
                    v-bind:value="'紙本寄送'">
                  <label class="form-check-label" for="RecommendationLetter_1">
                    紙本寄送
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="RecommendationLetter" id="RecommendationLetter_2"
                    v-model="ApplyData.Apply.RecommendationLetter" data-required="1" data-required-msg="請選擇推薦信提供方式"
                    v-bind:value="'提供電子檔'">
                  <label class="form-check-label" for="RecommendationLetter_2">
                    提供電子檔
                  </label>
                </div>
                <p class="red_color" style="display: block;" v-if="ApplyData.Apply.RecommendationLetter == '紙本寄送'">
                  *選擇紙本寄送者，請於信封外標示「線上報名序號」及「報名國際青年大使交流計畫」，並於報名期間內(以郵戳日期為憑)掛號郵寄至「外交部非政府組織國際事務會」，地址：100202台北市中正區凱達格蘭大道2號</p>
              </div>
            </div>
            <div class="group input-group full letter_box no-print" style="display: block;"
              v-if="ApplyData.Apply.RecommendationLetter == '提供電子檔'">
              <label class="form-label">推薦信電子檔上傳處 </label><span style="color: red;"
                v-if="ApplyData.Apply.AId != -1 && ApplyData.Apply.RecommendationFile && !ApplyData.LoginToken">(已上傳,
                可更新)</span>
              <a :href="RecommendationFile_Url" target="_blank"
                v-if="RecommendationFile_Url && ApplyData.LoginToken">另開新視窗檢視</a>
              <div class="file_preview" v-if="getPreviewUrl(ApplyData.Apply.RecommendationFile)">
                <img :src="getPreviewUrl(ApplyData.Apply.RecommendationFile)" alt="預覽圖">
              </div>
              <div class="file_box">
                <input type="file" class="form-control" id="RecommendationFile"
                  accept=".pdf,.bmp,.jpg,.gif,.tif,.png,.jpeg" @change="checkFiles">
                <input type="hidden" id="RecommendationFile_name" data-namgtag="1" />
                <input type="hidden" v-model="ApplyData.Apply.RecommendationFile" id="RecommendationFile_data"
                  :data-required="ApplyData.Apply.RecommendationLetter == '提供電子檔' ? '1' : '0'"
                  data-required-msg="請上傳推薦信電子檔上傳處" />
                <label class="input-group-text" for="RecommendationFile">上傳檔案</label>
              </div>
              <p class="upload_p">可上傳的檔案格式為 .pdf .bmp .jpg .gif .tif .png .jpeg </p>
            </div>
            <hr class="divider">
            <div class="group input-group full no-print">
              <label class="form-label">就讀國防部軍事院校與內政部警察大學之學生，請檢附校方同意函本部方受理報名 </label><span style="color: red;"
                v-if="ApplyData.Apply.AId != -1 && ApplyData.Apply.SchoolConsent && !ApplyData.LoginToken">(已上傳,
                可更新)</span>
              <a :href="SchoolConsent_Url" target="_blank" v-if="SchoolConsent_Url && ApplyData.LoginToken">另開新視窗檢視</a>
              <div class="file_preview" v-if="getPreviewUrl(ApplyData.Apply.SchoolConsent)">
                <img :src="getPreviewUrl(ApplyData.Apply.SchoolConsent)" alt="預覽圖">
              </div>
              <div class="file_box">
                <input type="file" class="form-control" id="SchoolConsent" accept=".pdf,.bmp,.jpg,.gif,.tif,.png,.jpeg"
                  @change="checkFiles">
                <input type="hidden" id="SchoolConsent_name" data-namgtag="1" />
                <input type="hidden" v-model="ApplyData.Apply.SchoolConsent" id="SchoolConsent_data" />
                <label class="input-group-text" for="SchoolConsent">上傳檔案</label>
              </div>
              <p class="upload_p">可上傳的檔案格式為 .pdf .bmp .jpg .gif .tif .png .jpeg </p>
            </div>
            <div class="group input-group full no-print">
              <label class="form-label">外語測驗或就讀大專院校外語成績單證明</label>
              <p class="red_color">*此為參考文件，未備齊者不影響報名資格&nbsp;</p><span style="color: red;"
                v-if="ApplyData.Apply.AId != -1 && ApplyData.Apply.LanguageTestProof && !ApplyData.LoginToken">(已上傳,
                可更新)</span>
              <a :href="LanguageTestProof_Url" target="_blank"
                v-if="LanguageTestProof_Url && ApplyData.LoginToken">另開新視窗檢視</a>
              <div class="file_preview" v-if="getPreviewUrl(ApplyData.Apply.LanguageTestProof)">
                <img :src="getPreviewUrl(ApplyData.Apply.LanguageTestProof)" alt="預覽圖">
              </div>
              <div class="file_box">
                <input type="file" class="form-control" id="LanguageTestProof"
                  accept=".pdf,.bmp,.jpg,.gif,.tif,.png,.jpeg" @change="checkFiles">
                <input type="hidden" id="LanguageTestProof_name" data-namgtag="1" />
                <input type="hidden" v-model="ApplyData.Apply.LanguageTestProof" id="LanguageTestProof_data" />
                <label class="input-group-text" for="LanguageTestProof">上傳檔案</label>
              </div>
              <p class="upload_p">可上傳的檔案格式為 .pdf .bmp .jpg .gif .tif .png .jpeg </p>
            </div>
            <div class="group input-group full no-print">
              <label class="form-label">才藝檢定證明或比賽得獎證明</label>
              <p class="red_color">*此為參考文件，未備齊者不影響報名資格&nbsp;</p><span style="color: red;"
                v-if="ApplyData.Apply.AId != -1 && ApplyData.Apply.TalentProof && !ApplyData.LoginToken">(已上傳,
                可更新)</span>
              <a :href="TalentProof_Url" target="_blank" v-if="TalentProof_Url && ApplyData.LoginToken">另開新視窗檢視</a>
              <div class="file_preview" v-if="getPreviewUrl(ApplyData.Apply.TalentProof)">
                <img :src="getPreviewUrl(ApplyData.Apply.TalentProof)" alt="預覽圖">
              </div>
              <div class="file_box">
                <input type="file" class="form-control" id="TalentProof" accept=".pdf,.bmp,.jpg,.gif,.tif,.png,.jpeg"
                  @change="checkFiles">
                <input type="hidden" id="TalentProof_name" data-namgtag="1" />
                <input type="hidden" v-model="ApplyData.Apply.TalentProof" id="TalentProof_data" />
                <label class="input-group-text" for="TalentProof">上傳檔案</label>
              </div>
              <p class="upload_p">可上傳的檔案格式為 .pdf .bmp .jpg .gif .tif .png .jpeg </p>
            </div>
            <div class="group full">
              <label class="form-label">上述上傳之檔案超過100MB，請自行上傳雲端，並提供雲端網址</label>
              <input type="text" class="form-control" placeholder="請輸入雲端網址" v-model="ApplyData.Apply.CloudFileURL">
            </div>
            <hr class="divider"
              v-show="!ApplyData.LoginToken && ApplyData.Apply.Status != 1 && ApplyData.Apply.Status != 2">
            <div class="group full"
              v-show="!ApplyData.LoginToken && ApplyData.Apply.Status != 1 && ApplyData.Apply.Status != 2">
              <div class="place_box">
                <div class="form-check">
                  <input class="form-check-input" id="IsAgree" name="IsAgree" type="checkbox" v-model="IsAgree">
                  <label class="form-check-label" for="IsAgree">
                    我已閱讀並同意<a href="javascript:void(0)" @click="showPrivacy()">隱私權保護及資訊安全政策</a>
                  </label>
                </div>
              </div>
            </div>
            <template v-if="ApplyData.LoginToken">
              <hr class="divider">
              <div class="group full">
                <label class="form-label">審核結果</label>
                <div class="gender_box">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="Status" id="Status_0"
                      v-model="ApplyData.Apply.Status" v-bind:value="0">
                    <label class="form-check-label" for="Status_0">
                      暫存
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="Status" id="Status_1"
                      v-model="ApplyData.Apply.Status" v-bind:value="1">
                    <label class="form-check-label" for="Status_1">
                      審核中
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="Status" id="Status_2"
                      v-model="ApplyData.Apply.Status" v-bind:value="2">
                    <label class="form-check-label" for="Status_2">
                      通過
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="Status" id="Status_3"
                      v-model="ApplyData.Apply.Status" v-bind:value="3">
                    <label class="form-check-label" for="Status_3">
                      未通過
                    </label>
                  </div>
                </div>
              </div>
              <div class="group full autobiography_box">
                <label class="form-label">審核說明</label>
                <textarea class="no-print" maxlength="400" v-model="ApplyData.Apply.ReviewContent"></textarea>
                <div class="print-only">{{ ApplyData.Apply.ReviewContent }}</div>
              </div>
            </template>
          </div>
        </div>
        <div class="reserve_send_btn" v-if="!ApplyData.LoginToken">
          <button class="reserve" type="button" data-bs-toggle="modal" data-bs-target="#reserve_box"
            v-if="ApplyData.Apply.Status == 0">暫存<br class="br_none">資料</button>
          <button class="send" type="button" data-bs-toggle="modal" data-bs-target="#send_box"
            v-if="ApplyData.Apply.Status == 0 || ApplyData.Apply.Status == 3">送出</button>
        </div>
        <div class="reserve_send_btn" v-if="ApplyData.LoginToken">
          <button class="send" type="button" @click="send()">儲存</button>
        </div>
      </div>
    </div><!-- wrapper -->
    <div class="modal fade reserve_send_btn_box" id="reserve_box" data-bs-backdrop="static" data-bs-keyboard="false"
      tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <h2><img src="img/icon_6.svg" alt="">暫存資料</h2>
            <p>
              請注意！「暫存資料」<span>並非</span>報名完成。
              <br>
              您可於報名期間修改報名資訊。資料確認無誤後，記得「送出」才算報名完成。
            </p>
            <div class="btn_box">
              <button type="button" class="" @click="save()">確認暫存</button>
              <button type="button" class="" data-bs-dismiss="modal">取消</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade reserve_send_btn_box" id="send_box" data-bs-backdrop="static" data-bs-keyboard="false"
      tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <h2><img src="img/icon_7.svg" alt="">送出</h2>
            <p>
              <span>資料送出後即報名完成，後續將無法進行修改。</span>
              <br>
              您填寫的資料將視為正確無誤，且代表您已詳細閱讀並同意遵守<strong>「{{ApplyData.SeasonName}}」</strong>等相關規定。
            </p>
            <div class="btn_box">
              <button type="button" class="" @click="send()">確認送出</button>
              <button type="button" class="" data-bs-dismiss="modal">取消</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterBlock />
  </div>
</template>
<script>
import FooterBlock from "@/components/FooterBlock.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
  },
  en: {
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "Apply",
  i18n,
  components: {
    FooterBlock,
    Slick,
  },
  data() {
    return {
      ApplyData: {},
      EditToken: "",
      local: "zh_tw",
      StudentIDOrProof_Url: "",
      PersonalPhoto_Url: "",
      MediaConsentForm_Url: "",
      RecommendationFile_Url: "",
      SchoolConsent_Url: "",
      LanguageTestProof_Url: "",
      TalentProof_Url: "",
      IsAgree: false,
      schools: [
        "國立政治大學", "國立清華大學", "國立臺灣大學", "國立臺灣師範大學",
        "國立成功大學", "國立中興大學", "國立陽明交通大學", "國立中央大學",
        "國立中山大學", "國立臺灣海洋大學", "國立中正大學", "國立高雄師範大學",
        "國立彰化師範大學", "國立臺北大學", "國立嘉義大學", "國立高雄大學",
        "國立東華大學", "國立暨南國際大學", "國立臺北藝術大學", "國立臺灣藝術大學",
        "國立臺東大學", "國立宜蘭大學", "國立聯合大學", "國立臺南藝術大學",
        "國立臺南大學", "國立臺北教育大學", "國立臺中教育大學", "國立體育大學",
        "國立金門大學", "國立臺灣體育運動大學", "國立屏東大學", "臺北市立大學",
        "國立臺灣科技大學", "國立雲林科技大學", "國立屏東科技大學", "國立臺北科技大學",
        "國立虎尾科技大學", "國立澎湖科技大學", "國立勤益科技大學", "國立臺北護理健康大學",
        "國立高雄餐旅大學", "國立臺中科技大學", "國立臺北商業大學", "國立高雄科技大學",
        "國立臺灣戲曲學院", "國立臺南護理專科學校", "國立臺東專科學校",
        "東海大學", "輔仁大學", "東吳大學", "中原大學", "淡江大學",
        "中國文化大學", "逢甲大學", "靜宜大學", "長庚大學", "元智大學",
        "中華大學", "大葉大學", "華梵大學", "義守大學", "世新大學",
        "銘傳大學", "實踐大學", "高雄醫學大學", "南華大學", "真理大學",
        "大同大學", "慈濟大學", "臺北醫學大學", "中山醫學大學", "長榮大學",
        "中國醫藥大學", "玄奘大學", "亞洲大學", "開南大學", "佛光大學",
        "康寧大學", "馬偕醫學大學", "中信金融管理學院", "法鼓文理學院",
        "台灣浸會神學院", "臺北基督學院", "台灣神學研究學院", "一貫道崇德學院",
        "南神神學院", "中華福音神學研究學院", "唯心聖教學院", "福智佛教學院",
        "朝陽科技大學", "南臺科技大學", "崑山科技大學", "嘉南藥理大學",
        "樹德科技大學", "龍華科技大學", "輔英科技大學", "明新科技大學",
        "弘光科技大學", "健行科技大學", "正修科技大學", "萬能科技大學",
        "建國科技大學", "明志科技大學", "台鋼科技大學", "大仁科技大學",
        "聖約翰科技大學", "嶺東科技大學", "中國科技大學", "中臺科技大學",
        "台南應用科技大學", "中信科技大學", "元培醫事科技大學", "景文科技大學",
        "中華醫事科技大學", "東南科技大學", "德明財經科技大學", "南開科技大學",
        "中華科技大學", "僑光科技大學", "育達科技大學", "美和科技大學",
        "吳鳳科技大學", "修平科技大學", "長庚科技大學", "臺北城市科技大學",
        "敏實科技大學", "醒吾科技大學", "文藻外語大學", "華夏科技大學",
        "致理科技大學", "宏國德霖科技大學", "崇右影藝科技大學", "台北海洋科技大學",
        "亞東科技大學", "南亞技術學院", "黎明技術學院", "德育護理健康學院",
        "馬偕醫護管理專科學校", "仁德醫護管理專科學校", "樹人醫護管理專科學校",
        "慈惠醫護管理專科學校", "耕莘健康管理專科學校", "敏惠醫護管理專科學校",
        "育英醫護管理專科學校", "聖母醫護管理專科學校", "新生醫護管理專科學校",
        "崇仁醫護管理專科學校", "國立空中大學", "高雄市立空中大學"
      ],
    };
  },
  beforeRouteUpdate(to, from, next) {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/Apply",
        {
          params: {
            lang: $cookies.get("gya_main_lang"),
            EditToken: to.params.EditToken
          },
        }
      )
      .then((response) => {
        this.ApplyData = response.data;
        if (this.ApplyData.Error) {
          Swal.fire({
            title: "錯誤",
            text: this.ApplyData.Error,
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定",
            heightAuto: false,
            willClose: () => {
              this.$router.push({
                name: "Home"
              });
            },
          });
          return;
        }
        this.EditToken = to.params.EditToken;
        if (this.ApplyData.Apply.BirthDate && this.ApplyData.Apply.BirthDate != "0001-01-01T00:00:00") {
          this.ApplyData.Apply.BirthDate = this.convertDatetimeString(this.ApplyData.Apply.BirthDate, "YYYY-MM-DD")
        } else {
          this.ApplyData.Apply.BirthDate = "";
        }
        if (this.ApplyData.LoginToken) {
          if (this.ApplyData.Apply.StudentIDOrProof) { this.StudentIDOrProof_Url = this.ApplyData.SiteUrl + this.ApplyData.Apply.StudentIDOrProof };
          if (this.ApplyData.Apply.PersonalPhoto) { this.PersonalPhoto_Url = this.ApplyData.SiteUrl + this.ApplyData.Apply.PersonalPhoto };
          if (this.ApplyData.Apply.MediaConsentForm) { this.MediaConsentForm_Url = this.ApplyData.SiteUrl + this.ApplyData.Apply.MediaConsentForm };
          if (this.ApplyData.Apply.RecommendationFile) { this.RecommendationFile_Url = this.ApplyData.SiteUrl + this.ApplyData.Apply.RecommendationFile };
          if (this.ApplyData.Apply.SchoolConsent) { this.SchoolConsent_Url = this.ApplyData.SiteUrl + this.ApplyData.Apply.SchoolConsent };
          if (this.ApplyData.Apply.LanguageTestProof) { this.LanguageTestProof_Url = this.ApplyData.SiteUrl + this.ApplyData.Apply.LanguageTestProof };
          if (this.ApplyData.Apply.TalentProof) { this.TalentProof_Url = this.ApplyData.SiteUrl + this.ApplyData.Apply.TalentProof };
        }
        $('html,body').animate({ scrollTop: 0 }, 1000);
      })
      .catch((error) => {
        console.log(error);
      });
    next();
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/Apply",
        {
          params: {
            lang: $cookies.get("gya_main_lang"),
            EditToken: this.$route.params.EditToken
          },
        }
      )
      .then((response) => {
        this.ApplyData = response.data;
        if (this.ApplyData.Error) {
          Swal.fire({
            title: "錯誤",
            text: this.ApplyData.Error,
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定",
            heightAuto: false,
            willClose: () => {
              this.$router.push({
                name: "Home"
              });
            },
          });
          return;
        }
        this.EditToken = this.$route.params.EditToken;
        if (this.ApplyData.Apply.BirthDate && this.ApplyData.Apply.BirthDate != "0001-01-01T00:00:00") {
          this.ApplyData.Apply.BirthDate = this.convertDatetimeString(this.ApplyData.Apply.BirthDate, "YYYY-MM-DD")
        } else {
          this.ApplyData.Apply.BirthDate = "";
        }
        if (this.ApplyData.LoginToken) {
          if (this.ApplyData.Apply.StudentIDOrProof) { this.StudentIDOrProof_Url = this.ApplyData.SiteUrl + this.ApplyData.Apply.StudentIDOrProof };
          if (this.ApplyData.Apply.PersonalPhoto) { this.PersonalPhoto_Url = this.ApplyData.SiteUrl + this.ApplyData.Apply.PersonalPhoto };
          if (this.ApplyData.Apply.MediaConsentForm) { this.MediaConsentForm_Url = this.ApplyData.SiteUrl + this.ApplyData.Apply.MediaConsentForm };
          if (this.ApplyData.Apply.RecommendationFile) { this.RecommendationFile_Url = this.ApplyData.SiteUrl + this.ApplyData.Apply.RecommendationFile };
          if (this.ApplyData.Apply.SchoolConsent) { this.SchoolConsent_Url = this.ApplyData.SiteUrl + this.ApplyData.Apply.SchoolConsent };
          if (this.ApplyData.Apply.LanguageTestProof) { this.LanguageTestProof_Url = this.ApplyData.SiteUrl + this.ApplyData.Apply.LanguageTestProof };
          if (this.ApplyData.Apply.TalentProof) { this.TalentProof_Url = this.ApplyData.SiteUrl + this.ApplyData.Apply.TalentProof };
        }
        $('html,body').animate({ scrollTop: 0 }, 1000);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("gya_main_lang")) {
      i18n.locale = $cookies.get("gya_main_lang");
      this.local = $cookies.get("gya_main_lang");
    } else {
      i18n.locale = $cookies.get("gya_main_lang");
      this.local = "zh_tw";
    }
    // 回頂端 暫存資料按鈕位置變動
    $("html body").scroll(function () {
      let N = $("html body").scrollTop();
      const windowHeight = $(window).height();
      const documentHeight = $(document).height() - windowHeight;
      if (N > 400) {
        $('.top_btn').css('display', 'block');
        $('.reserve_send_btn .reserve_fixed').css('display', 'block');
      }
      else {
        $('.top_btn').css('display', 'none');
        $('.reserve_send_btn .reserve_fixed').css('display', 'none');
      };
      if (N > documentHeight - 300) {
        $('.reserve_send_btn .reserve').removeClass("reserve_fixed");
      }
      else {
        $('.reserve_send_btn .reserve').addClass("reserve_fixed");
      };
    });
  },
  updated: function () {
    if (this.ApplyData &&
      !this.ApplyData.LoginToken &&
      this.ApplyData.Apply.Status != 0 &&
      this.ApplyData.Apply.Status != 3) {
      $(".form_box").find("input, textarea, select, button").prop("disabled", true);
    }
  },
  watch: {
    'ApplyData.Apply': function (newVal) {
      if (!newVal) return;
      var that = this;
      this.$nextTick(function () {
        var $select = $('#schoolSelect');
        if (!$select.hasClass('select2-hidden-accessible')) {
          $select.select2({
            tags: false,
            placeholder: '請選擇或輸入就讀學校',
            allowClear: true,
            width: '100%',
            language: {
              noResults: function () { return '查無此學校'; },
              searching: function () { return '搜尋中...'; }
            },
            data: [{ id: '', text: '' }].concat(
              that.schools.map(function (s) { return { id: s, text: s }; })
            )
          }).on('change', function () {
            if (that.ApplyData && that.ApplyData.Apply) {
              that.ApplyData.Apply.School = $(this).val() || '';
            }
          });
        }
        var schoolVal = newVal.School || '';
        if (schoolVal && !$select.find('option[value="' + schoolVal.replace(/"/g, '\\"') + '"]').length) {
          $select.append(new Option(schoolVal, schoolVal));
        }
        $select.val(schoolVal).trigger('change.select2');
      });
    }
  },
  methods: {
    toTop() {
      $('html,body').animate({ scrollTop: 0 }, 1000);
    },
    checkFiles(event) {
      let that = this;
      var id = event.target.id;
      var e = event.target;
      if (e.files.length != 0) {
        // 顯示請稍候
        Swal.fire({
          title: that.$t("請稍候..."),
          allowOutsideClick: false,
          showConfirmButton: false,
          heightAuto: false,
          willOpen: function () {
            Swal.showLoading();
          },
        });
        var file = e.files[0];
        // 不進行壓縮的情況要檢查大小
        if (file.size > 104857600) {
          Swal.fire({
            title: that.$t("錯誤"),
            text: that.$t("檔案大小超過100MB"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
            heightAuto: false,
          });
        } else {
          var reader = new FileReader();
          reader.onloadend = function () {
            if (id == "StudentIDOrProof") {
              that.ApplyData.Apply.StudentIDOrProof = reader.result;
            } else if (id == "PersonalPhoto") {
              that.ApplyData.Apply.PersonalPhoto = reader.result;
            } else if (id == "MediaConsentForm") {
              that.ApplyData.Apply.MediaConsentForm = reader.result;
            } else if (id == "RecommendationFile") {
              that.ApplyData.Apply.RecommendationFile = reader.result;
            } else if (id == "SchoolConsent") {
              that.ApplyData.Apply.SchoolConsent = reader.result;
            } else if (id == "LanguageTestProof") {
              that.ApplyData.Apply.LanguageTestProof = reader.result;
            } else if (id == "TalentProof") {
              that.ApplyData.Apply.TalentProof = reader.result;
            }
            $("#" + id + "_data").val(reader.result);
            $("#" + id + "_name").val(file.name);
            //$("#" + id).val('');
            Swal.close();
          };
          reader.onerror = function (error) {
            $("#" + id).val("");
            Swal.fire({
              title: that.$t("錯誤"),
              html:
                that.$t("處理檔案過程發生錯誤:") + "<br />" +
                error +
                "<br />" + that.$t("若持續發生此問題請聯繫客服人員, 造成不便敬請見諒"),
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
              heightAuto: false,
            });
          };
          reader.readAsDataURL(file);
        }
      }
    },
    save() {
      $('#reserve_box').modal('hide');
      $('#send_box').modal('hide');
      let that = this;
      // 暫存必填姓名及證號
      if (!that.ApplyData.Apply.Name || !that.ApplyData.Apply.IDNumber || !that.ApplyData.Apply.Email) {
        Swal.fire({
          title: "錯誤",
          text: "若要保留檔案請至少填寫姓名、身份證字號及電子郵件, 以便後續更新",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return false;
      }
      Swal.fire({
        title: "請稍候...",
        allowOutsideClick: false,
        showConfirmButton: false,
        heightAuto: false,
        willOpen: function () {
          Swal.showLoading();
        },
      });
      // 儲存檔案名稱
      var AttachmentNames = "{";
      $("[data-namgtag='1']").each(function () {
        if (AttachmentNames.length > 1) { AttachmentNames += ", "; }
        var input = $(this);
        AttachmentNames += '"' + input.attr("id").replace("_name", "") + '": "' + input.val() + '"';
      });
      AttachmentNames += "}";
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/Apply",
        type: "post",
        data: {
          ApplyJson: JSON.stringify(that.ApplyData.Apply),
          AttachmentNames: AttachmentNames,
          Sended: false
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.ok) {
            Swal.fire({
              title: "儲存成功",
              icon: "success",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
              willClose: () => {
                that.$router.push({
                  name: "Home"
                });
              },
            });
          } else if (res.error) {
            Swal.fire({
              title: "錯誤",
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          }
        }
      });
    },
    send() {
      $('#reserve_box').modal('hide');
      $('#send_box').modal('hide');
      let that = this;
      var hasError = false;
      $(".form_box").find("[data-required='1']").each(function () {
        var input = $(this);
        if (!input.val() || input.val() == '-1') {
          Swal.fire({
            title: "錯誤",
            text: input.data("required-msg"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定",
            heightAuto: false,
            willClose: () => {
              //input.focus();
            },
          });
          hasError = true;
          return false;
        } else if (input.attr("type") == "email" &&
          !Validate.reg_email(input.val())) {
          Swal.fire({
            title: "錯誤",
            text: "Email格式錯誤",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定",
            heightAuto: false,
          });
          hasError = true;
          return false;
        }
      });
      if (!that.ApplyData.Apply.Gender) {
        Swal.fire({
          title: "錯誤",
          text: "請選擇性別",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        hasError = true;
        return false;
      }
      if (!that.ApplyData.Apply.Specialty) {
        Swal.fire({
          title: "錯誤",
          text: "請選擇應試專長",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        hasError = true;
        return false;
      }
      if (!that.ApplyData.Apply.PreferredLocation) {
        Swal.fire({
          title: "錯誤",
          text: "請選擇複選地點",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        hasError = true;
        return false;
      }
      if (!that.ApplyData.Apply.RecommendationLetter) {
        Swal.fire({
          title: "錯誤",
          text: "請選擇推薦信提供方式",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        hasError = true;
        return false;
      }
      if (
        !that.ApplyData.Apply.PhoneNumber.startsWith("09") ||
        that.ApplyData.Apply.PhoneNumber.length != 10
      ) {
        Swal.fire({
          heightAuto: false,
          title: "錯誤",
          text: "聯絡電話格式錯誤",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
        });
        return;
      }
      if (
        !that.ApplyData.Apply.EmergencyContactPhone.startsWith("09") ||
        that.ApplyData.Apply.EmergencyContactPhone.length != 10
      ) {
        Swal.fire({
          heightAuto: false,
          title: "錯誤",
          text: "緊急聯絡人手機號碼格式錯誤",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
        });
        return;
      }
      // 非修改需勾選
      if (!that.ApplyData.LoginToken && !that.IsAgree) {
        Swal.fire({
          title: "錯誤",
          text: "請詳細閱讀並勾選「我已閱讀並同意隱私權保護及資訊安全政策」",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return false;
      }
      if (hasError) {
        return;
      }
      Swal.fire({
        title: "請稍候...",
        allowOutsideClick: false,
        showConfirmButton: false,
        heightAuto: false,
        willOpen: function () {
          Swal.showLoading();
        },
      });
      // 儲存檔案名稱
      var AttachmentNames = "{";
      $("[data-namgtag='1']").each(function () {
        if (AttachmentNames.length > 1) { AttachmentNames += ", "; }
        var input = $(this);
        AttachmentNames += '"' + input.attr("id").replace("_name", "") + '": "' + input.val() + '"';
      });
      AttachmentNames += "}";
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/Apply",
        type: "post",
        data: {
          ApplyJson: JSON.stringify(that.ApplyData.Apply),
          AttachmentNames: AttachmentNames,
          Sended: true,
          LoginToken: that.ApplyData.LoginToken
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.ok) {
            Swal.fire({
              title: "儲存成功",
              icon: "success",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
              willClose: () => {
                if (!that.ApplyData.LoginToken) {
                  that.$router.push({
                    name: "Home"
                  });
                } else {
                  location.reload();
                }
              },
            });
          } else if (res.error) {
            Swal.fire({
              title: "錯誤",
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          }
        }
      });
    },
    convertDatetimeString(time, format) {
      var date = new Date(
        time.replace(
          /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
          "$4:$5:$6 $2/$3/$1"
        )
      );
      return moment(date).format(format);
    },
    showPrivacy() {
      let that = this;
      Swal.fire({
        title: "隱私權保護及資訊安全政策",
        customClass: {
          htmlContainer: 'privacy-html-class'
        },
        html: that.ApplyData.Privacy_Text,
        allowOutsideClick: false,
        confirmButtonText: "確定",
        heightAuto: false,
        width: '900px'
      });
    },
    print() {
      window.print();
    },
    getPreviewUrl(fileData) {
      if (!fileData) return null;
      if (fileData.startsWith('data:image/')) return fileData;
      if (/\.(jpg|jpeg|png|gif|bmp|tif|tiff)$/i.test(fileData)) {
        return (this.ApplyData && this.ApplyData.SiteUrl ? this.ApplyData.SiteUrl : '') + fileData;
      }
      return null;
    },
  },
};
</script>

<style scoped>
.file_preview {
  width: 100%;
  margin-top: 8px;
  margin-bottom: 8px;
}

.file_preview img {
  max-width: 300px;
  max-height: 300px;
  border: 1px solid #ddd;
  border-radius: 4px;
  object-fit: contain;
  display: block;
}

.print-only {
  display: none;
}

@media print {
  .no-print {
    display: none !important;
  }

  .print-only {
    display: block;
    white-space: pre-wrap;
    word-break: break-word;
  }
}
</style>